import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const FloatingProfile = () => {
  const { user } = useAuth();
  const [avatar, setAvatar] = useState<string | null>(null);
  
  useEffect(() => {
    if (user) {
      fetch('/api/profile/data')
      .then(r => r.json())
      .then(({ data }) => {
        if (data?.avatar_url) setAvatar(data.avatar_url);
      })
      .catch(err => console.error("Error fetching floating profile avatar:", err));
    }
  }, [user]);

  return (
    <Link 
      to="/app/perfil" 
      className="fixed top-4 right-4 z-50 w-11 h-11 rounded-full bg-card shadow-soft border-2 border-primary/20 flex items-center justify-center text-primary overflow-hidden hover:scale-105 transition-transform"
    >
      {avatar ? (
        <img src={avatar} alt="Perfil" className="w-full h-full object-cover" />
      ) : (
        <User className="h-5 w-5" />
      )}
    </Link>
  );
};

export default FloatingProfile;
